import { CommonModule } from '@angular/common';
import { Component, OnInit, signal, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ClozeTestStyleModel } from 'gast-onset-ng2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnsetExamDataDto } from '../../shared/dtos/onset-exam-data-dto';
import { ConnectorAuthService } from '../../shared/services/common/connector-auth.service';
import { ConnectorService } from '../../shared/services/idas/connector.service';

@Component({
  selector: 'app-connector',
  templateUrl: './connector.component.html',
  styleUrls: ['./connector.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class ConnectorComponent implements OnInit {

  readonly #deviceService = inject(DeviceDetectorService);
  readonly #connectorService = inject(ConnectorService);
  readonly #authService = inject(ConnectorAuthService);
  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);

  title = signal('');
  subtitle = signal('');
  content = signal('');
  clozeTestStyleModel = signal<ClozeTestStyleModel | null>({} as ClozeTestStyleModel);
  cTestLogo = signal('');
  cTestButtonColor = signal('');
  mobileMode = signal(false);
  totalExercise = signal(0);
  currentExcerciseNumber = signal(0);
  onsetExamDataDto = signal<OnsetExamDataDto | null>({} as OnsetExamDataDto);
  isLoading = signal(false);
  env = signal('');

  ngOnInit() {
    // detect mobile
    this.mobileMode.set(this.#deviceService.isMobile());
    console.log('is mobile device: ' + this.mobileMode());

    // generate style
    this.clozeTestStyleModel.set(this.#generateClozeTestStyle());

    // sett logo and button color
    this.cTestLogo.set('onset-assets/img/onset_logo.png');
    this.cTestButtonColor.set(this.clozeTestStyleModel()!.onsetColor);

    this.#connectorService.getOnsetExamDataCompleted.subscribe((onsetExamDataDto: OnsetExamDataDto) => {
      this.onsetExamDataDto.set(onsetExamDataDto);
      this.isLoading.set(false);

      this.#authService.login(onsetExamDataDto);
    });

    // callback for query parameter
    this.#route.queryParams.subscribe(params => {
      if (params['token']) {
        const token = params['token'] as string;
        if (params['env']) {
          this.env.set(params['env']);
        }

        this.#connectorService.getOnsetExamData(token, this.env());
        this.isLoading.set(true);
      }

    });
  }

  startOnset(): void {
    this.#router.navigate(['connector-onset'], { queryParamsHandling: 'preserve' });
  }

  #generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'http://www.wikipedia.com/';
    return model;
  }
}
